import * as Q from "react";
import Kr, { forwardRef as Hr, useContext as Mt, useMemo as kr } from "react";
import { isArray as jt, isObject as Vt } from "@illa-design/system";
import { css as B, keyframes as Lt } from "@emotion/react";
import { applyBoxStyle as fr, deleteCssProps as lr } from "@illa-design/theme";
var ar = { exports: {} }, Ee = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var $r;
function Yt() {
  if ($r)
    return Ee;
  $r = 1;
  var e = Kr, r = Symbol.for("react.element"), n = Symbol.for("react.fragment"), a = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function l(f, p, m) {
    var d, y = {}, k = null, $ = null;
    m !== void 0 && (k = "" + m), p.key !== void 0 && (k = "" + p.key), p.ref !== void 0 && ($ = p.ref);
    for (d in p)
      a.call(p, d) && !i.hasOwnProperty(d) && (y[d] = p[d]);
    if (f && f.defaultProps)
      for (d in p = f.defaultProps, p)
        y[d] === void 0 && (y[d] = p[d]);
    return { $$typeof: r, type: f, key: k, ref: $, props: y, _owner: o.current };
  }
  return Ee.Fragment = n, Ee.jsx = l, Ee.jsxs = l, Ee;
}
var ge = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ir;
function Wt() {
  return Ir || (Ir = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Kr, r = Symbol.for("react.element"), n = Symbol.for("react.portal"), a = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), l = Symbol.for("react.provider"), f = Symbol.for("react.context"), p = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), y = Symbol.for("react.memo"), k = Symbol.for("react.lazy"), $ = Symbol.for("react.offscreen"), A = Symbol.iterator, b = "@@iterator";
    function F(t) {
      if (t === null || typeof t != "object")
        return null;
      var s = A && t[A] || t[b];
      return typeof s == "function" ? s : null;
    }
    var S = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function E(t) {
      {
        for (var s = arguments.length, u = new Array(s > 1 ? s - 1 : 0), h = 1; h < s; h++)
          u[h - 1] = arguments[h];
        P("error", t, u);
      }
    }
    function P(t, s, u) {
      {
        var h = S.ReactDebugCurrentFrame, x = h.getStackAddendum();
        x !== "" && (s += "%s", u = u.concat([x]));
        var N = u.map(function(_) {
          return String(_);
        });
        N.unshift("Warning: " + s), Function.prototype.apply.call(console[t], console, N);
      }
    }
    var I = !1, c = !1, V = !1, O = !1, Be = !1, Ce;
    Ce = Symbol.for("react.module.reference");
    function Ge(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === a || t === i || Be || t === o || t === m || t === d || O || t === $ || I || c || V || typeof t == "object" && t !== null && (t.$$typeof === k || t.$$typeof === y || t.$$typeof === l || t.$$typeof === f || t.$$typeof === p || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Ce || t.getModuleId !== void 0));
    }
    function Je(t, s, u) {
      var h = t.displayName;
      if (h)
        return h;
      var x = s.displayName || s.name || "";
      return x !== "" ? u + "(" + x + ")" : u;
    }
    function Te(t) {
      return t.displayName || "Context";
    }
    function G(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && E("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case a:
          return "Fragment";
        case n:
          return "Portal";
        case i:
          return "Profiler";
        case o:
          return "StrictMode";
        case m:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case f:
            var s = t;
            return Te(s) + ".Consumer";
          case l:
            var u = t;
            return Te(u._context) + ".Provider";
          case p:
            return Je(t, t.render, "ForwardRef");
          case y:
            var h = t.displayName || null;
            return h !== null ? h : G(t.type) || "Memo";
          case k: {
            var x = t, N = x._payload, _ = x._init;
            try {
              return G(_(N));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var Z = Object.assign, ee = 0, Oe, Pe, le, Ae, de, Ne, ke;
    function $e() {
    }
    $e.__reactDisabledLog = !0;
    function Ke() {
      {
        if (ee === 0) {
          Oe = console.log, Pe = console.info, le = console.warn, Ae = console.error, de = console.group, Ne = console.groupCollapsed, ke = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: $e,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function He() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Z({}, t, {
              value: Oe
            }),
            info: Z({}, t, {
              value: Pe
            }),
            warn: Z({}, t, {
              value: le
            }),
            error: Z({}, t, {
              value: Ae
            }),
            group: Z({}, t, {
              value: de
            }),
            groupCollapsed: Z({}, t, {
              value: Ne
            }),
            groupEnd: Z({}, t, {
              value: ke
            })
          });
        }
        ee < 0 && E("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var pe = S.ReactCurrentDispatcher, ve;
    function ne(t, s, u) {
      {
        if (ve === void 0)
          try {
            throw Error();
          } catch (x) {
            var h = x.stack.trim().match(/\n( *(at )?)/);
            ve = h && h[1] || "";
          }
        return `
` + ve + t;
      }
    }
    var me = !1, ae;
    {
      var Ze = typeof WeakMap == "function" ? WeakMap : Map;
      ae = new Ze();
    }
    function v(t, s) {
      if (!t || me)
        return "";
      {
        var u = ae.get(t);
        if (u !== void 0)
          return u;
      }
      var h;
      me = !0;
      var x = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var N;
      N = pe.current, pe.current = null, Ke();
      try {
        if (s) {
          var _ = function() {
            throw Error();
          };
          if (Object.defineProperty(_.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(_, []);
            } catch (X) {
              h = X;
            }
            Reflect.construct(t, [], _);
          } else {
            try {
              _.call();
            } catch (X) {
              h = X;
            }
            t.call(_.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (X) {
            h = X;
          }
          t();
        }
      } catch (X) {
        if (X && h && typeof X.stack == "string") {
          for (var g = X.stack.split(`
`), W = h.stack.split(`
`), D = g.length - 1, M = W.length - 1; D >= 1 && M >= 0 && g[D] !== W[M]; )
            M--;
          for (; D >= 1 && M >= 0; D--, M--)
            if (g[D] !== W[M]) {
              if (D !== 1 || M !== 1)
                do
                  if (D--, M--, M < 0 || g[D] !== W[M]) {
                    var q = `
` + g[D].replace(" at new ", " at ");
                    return t.displayName && q.includes("<anonymous>") && (q = q.replace("<anonymous>", t.displayName)), typeof t == "function" && ae.set(t, q), q;
                  }
                while (D >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        me = !1, pe.current = N, He(), Error.prepareStackTrace = x;
      }
      var se = t ? t.displayName || t.name : "", Nr = se ? ne(se) : "";
      return typeof t == "function" && ae.set(t, Nr), Nr;
    }
    function he(t, s, u) {
      return v(t, !1);
    }
    function oe(t) {
      var s = t.prototype;
      return !!(s && s.isReactComponent);
    }
    function re(t, s, u) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return v(t, oe(t));
      if (typeof t == "string")
        return ne(t);
      switch (t) {
        case m:
          return ne("Suspense");
        case d:
          return ne("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case p:
            return he(t.render);
          case y:
            return re(t.type, s, u);
          case k: {
            var h = t, x = h._payload, N = h._init;
            try {
              return re(N(x), s, u);
            } catch {
            }
          }
        }
      return "";
    }
    var Ie = Object.prototype.hasOwnProperty, gr = {}, br = S.ReactDebugCurrentFrame;
    function De(t) {
      if (t) {
        var s = t._owner, u = re(t.type, t._source, s ? s.type : null);
        br.setExtraStackFrame(u);
      } else
        br.setExtraStackFrame(null);
    }
    function yt(t, s, u, h, x) {
      {
        var N = Function.call.bind(Ie);
        for (var _ in t)
          if (N(t, _)) {
            var g = void 0;
            try {
              if (typeof t[_] != "function") {
                var W = Error((h || "React class") + ": " + u + " type `" + _ + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[_] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw W.name = "Invariant Violation", W;
              }
              g = t[_](s, _, h, u, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (D) {
              g = D;
            }
            g && !(g instanceof Error) && (De(x), E("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", h || "React class", u, _, typeof g), De(null)), g instanceof Error && !(g.message in gr) && (gr[g.message] = !0, De(x), E("Failed %s type: %s", u, g.message), De(null));
          }
      }
    }
    var Et = Array.isArray;
    function Xe(t) {
      return Et(t);
    }
    function gt(t) {
      {
        var s = typeof Symbol == "function" && Symbol.toStringTag, u = s && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return u;
      }
    }
    function bt(t) {
      try {
        return _r(t), !1;
      } catch {
        return !0;
      }
    }
    function _r(t) {
      return "" + t;
    }
    function Sr(t) {
      if (bt(t))
        return E("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", gt(t)), _r(t);
    }
    var ye = S.ReactCurrentOwner, _t = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, xr, Rr, Qe;
    Qe = {};
    function St(t) {
      if (Ie.call(t, "ref")) {
        var s = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (s && s.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function xt(t) {
      if (Ie.call(t, "key")) {
        var s = Object.getOwnPropertyDescriptor(t, "key").get;
        if (s && s.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function Rt(t, s) {
      if (typeof t.ref == "string" && ye.current && s && ye.current.stateNode !== s) {
        var u = G(ye.current.type);
        Qe[u] || (E('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', G(ye.current.type), t.ref), Qe[u] = !0);
      }
    }
    function wt(t, s) {
      {
        var u = function() {
          xr || (xr = !0, E("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", s));
        };
        u.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: u,
          configurable: !0
        });
      }
    }
    function Ct(t, s) {
      {
        var u = function() {
          Rr || (Rr = !0, E("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", s));
        };
        u.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: u,
          configurable: !0
        });
      }
    }
    var Tt = function(t, s, u, h, x, N, _) {
      var g = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: r,
        // Built-in properties that belong on the element
        type: t,
        key: s,
        ref: u,
        props: _,
        // Record the component responsible for creating this element.
        _owner: N
      };
      return g._store = {}, Object.defineProperty(g._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(g, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: h
      }), Object.defineProperty(g, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: x
      }), Object.freeze && (Object.freeze(g.props), Object.freeze(g)), g;
    };
    function Ot(t, s, u, h, x) {
      {
        var N, _ = {}, g = null, W = null;
        u !== void 0 && (Sr(u), g = "" + u), xt(s) && (Sr(s.key), g = "" + s.key), St(s) && (W = s.ref, Rt(s, x));
        for (N in s)
          Ie.call(s, N) && !_t.hasOwnProperty(N) && (_[N] = s[N]);
        if (t && t.defaultProps) {
          var D = t.defaultProps;
          for (N in D)
            _[N] === void 0 && (_[N] = D[N]);
        }
        if (g || W) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          g && wt(_, M), W && Ct(_, M);
        }
        return Tt(t, g, W, x, h, ye.current, _);
      }
    }
    var er = S.ReactCurrentOwner, wr = S.ReactDebugCurrentFrame;
    function ie(t) {
      if (t) {
        var s = t._owner, u = re(t.type, t._source, s ? s.type : null);
        wr.setExtraStackFrame(u);
      } else
        wr.setExtraStackFrame(null);
    }
    var rr;
    rr = !1;
    function tr(t) {
      return typeof t == "object" && t !== null && t.$$typeof === r;
    }
    function Cr() {
      {
        if (er.current) {
          var t = G(er.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Pt(t) {
      {
        if (t !== void 0) {
          var s = t.fileName.replace(/^.*[\\\/]/, ""), u = t.lineNumber;
          return `

Check your code at ` + s + ":" + u + ".";
        }
        return "";
      }
    }
    var Tr = {};
    function At(t) {
      {
        var s = Cr();
        if (!s) {
          var u = typeof t == "string" ? t : t.displayName || t.name;
          u && (s = `

Check the top-level render call using <` + u + ">.");
        }
        return s;
      }
    }
    function Or(t, s) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var u = At(s);
        if (Tr[u])
          return;
        Tr[u] = !0;
        var h = "";
        t && t._owner && t._owner !== er.current && (h = " It was passed a child from " + G(t._owner.type) + "."), ie(t), E('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', u, h), ie(null);
      }
    }
    function Pr(t, s) {
      {
        if (typeof t != "object")
          return;
        if (Xe(t))
          for (var u = 0; u < t.length; u++) {
            var h = t[u];
            tr(h) && Or(h, s);
          }
        else if (tr(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var x = F(t);
          if (typeof x == "function" && x !== t.entries)
            for (var N = x.call(t), _; !(_ = N.next()).done; )
              tr(_.value) && Or(_.value, s);
        }
      }
    }
    function Nt(t) {
      {
        var s = t.type;
        if (s == null || typeof s == "string")
          return;
        var u;
        if (typeof s == "function")
          u = s.propTypes;
        else if (typeof s == "object" && (s.$$typeof === p || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        s.$$typeof === y))
          u = s.propTypes;
        else
          return;
        if (u) {
          var h = G(s);
          yt(u, t.props, "prop", h, t);
        } else if (s.PropTypes !== void 0 && !rr) {
          rr = !0;
          var x = G(s);
          E("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", x || "Unknown");
        }
        typeof s.getDefaultProps == "function" && !s.getDefaultProps.isReactClassApproved && E("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function kt(t) {
      {
        for (var s = Object.keys(t.props), u = 0; u < s.length; u++) {
          var h = s[u];
          if (h !== "children" && h !== "key") {
            ie(t), E("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", h), ie(null);
            break;
          }
        }
        t.ref !== null && (ie(t), E("Invalid attribute `ref` supplied to `React.Fragment`."), ie(null));
      }
    }
    function Ar(t, s, u, h, x, N) {
      {
        var _ = Ge(t);
        if (!_) {
          var g = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (g += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var W = Pt(x);
          W ? g += W : g += Cr();
          var D;
          t === null ? D = "null" : Xe(t) ? D = "array" : t !== void 0 && t.$$typeof === r ? (D = "<" + (G(t.type) || "Unknown") + " />", g = " Did you accidentally export a JSX literal instead of a component?") : D = typeof t, E("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", D, g);
        }
        var M = Ot(t, s, u, x, N);
        if (M == null)
          return M;
        if (_) {
          var q = s.children;
          if (q !== void 0)
            if (h)
              if (Xe(q)) {
                for (var se = 0; se < q.length; se++)
                  Pr(q[se], t);
                Object.freeze && Object.freeze(q);
              } else
                E("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Pr(q, t);
        }
        return t === a ? kt(M) : Nt(M), M;
      }
    }
    function $t(t, s, u) {
      return Ar(t, s, u, !0);
    }
    function It(t, s, u) {
      return Ar(t, s, u, !1);
    }
    var Dt = It, Ft = $t;
    ge.Fragment = a, ge.jsx = Dt, ge.jsxs = Ft;
  }()), ge;
}
process.env.NODE_ENV === "production" ? ar.exports = Yt() : ar.exports = Wt();
var _e = ar.exports;
function zt(e) {
  if (e.sheet)
    return e.sheet;
  for (var r = 0; r < document.styleSheets.length; r++)
    if (document.styleSheets[r].ownerNode === e)
      return document.styleSheets[r];
}
function Ut(e) {
  var r = document.createElement("style");
  return r.setAttribute("data-emotion", e.key), e.nonce !== void 0 && r.setAttribute("nonce", e.nonce), r.appendChild(document.createTextNode("")), r.setAttribute("data-s", ""), r;
}
var qt = /* @__PURE__ */ function() {
  function e(n) {
    var a = this;
    this._insertTag = function(o) {
      var i;
      a.tags.length === 0 ? a.insertionPoint ? i = a.insertionPoint.nextSibling : a.prepend ? i = a.container.firstChild : i = a.before : i = a.tags[a.tags.length - 1].nextSibling, a.container.insertBefore(o, i), a.tags.push(o);
    }, this.isSpeedy = n.speedy === void 0 ? process.env.NODE_ENV === "production" : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.insertionPoint = n.insertionPoint, this.before = null;
  }
  var r = e.prototype;
  return r.hydrate = function(a) {
    a.forEach(this._insertTag);
  }, r.insert = function(a) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(Ut(this));
    var o = this.tags[this.tags.length - 1];
    if (process.env.NODE_ENV !== "production") {
      var i = a.charCodeAt(0) === 64 && a.charCodeAt(1) === 105;
      i && this._alreadyInsertedOrderInsensitiveRule && console.error(`You're attempting to insert the following rule:
` + a + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules."), this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !i;
    }
    if (this.isSpeedy) {
      var l = zt(o);
      try {
        l.insertRule(a, l.cssRules.length);
      } catch (f) {
        process.env.NODE_ENV !== "production" && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(a) && console.error('There was a problem inserting the following rule: "' + a + '"', f);
      }
    } else
      o.appendChild(document.createTextNode(a));
    this.ctr++;
  }, r.flush = function() {
    this.tags.forEach(function(a) {
      return a.parentNode && a.parentNode.removeChild(a);
    }), this.tags = [], this.ctr = 0, process.env.NODE_ENV !== "production" && (this._alreadyInsertedOrderInsensitiveRule = !1);
  }, e;
}(), Y = "-ms-", Le = "-moz-", R = "-webkit-", dr = "comm", pr = "rule", vr = "decl", Bt = "@import", Zr = "@keyframes", Gt = "@layer", Jt = Math.abs, We = String.fromCharCode, Kt = Object.assign;
function Ht(e, r) {
  return L(e, 0) ^ 45 ? (((r << 2 ^ L(e, 0)) << 2 ^ L(e, 1)) << 2 ^ L(e, 2)) << 2 ^ L(e, 3) : 0;
}
function Xr(e) {
  return e.trim();
}
function Zt(e, r) {
  return (e = r.exec(e)) ? e[0] : e;
}
function w(e, r, n) {
  return e.replace(r, n);
}
function or(e, r) {
  return e.indexOf(r);
}
function L(e, r) {
  return e.charCodeAt(r) | 0;
}
function Se(e, r, n) {
  return e.slice(r, n);
}
function K(e) {
  return e.length;
}
function mr(e) {
  return e.length;
}
function Fe(e, r) {
  return r.push(e), e;
}
function Xt(e, r) {
  return e.map(r).join("");
}
var ze = 1, ue = 1, Qr = 0, z = 0, j = 0, fe = "";
function Ue(e, r, n, a, o, i, l) {
  return { value: e, root: r, parent: n, type: a, props: o, children: i, line: ze, column: ue, length: l, return: "" };
}
function be(e, r) {
  return Kt(Ue("", null, null, "", null, null, 0), e, { length: -e.length }, r);
}
function Qt() {
  return j;
}
function en() {
  return j = z > 0 ? L(fe, --z) : 0, ue--, j === 10 && (ue = 1, ze--), j;
}
function U() {
  return j = z < Qr ? L(fe, z++) : 0, ue++, j === 10 && (ue = 1, ze++), j;
}
function H() {
  return L(fe, z);
}
function Me() {
  return z;
}
function we(e, r) {
  return Se(fe, e, r);
}
function xe(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function et(e) {
  return ze = ue = 1, Qr = K(fe = e), z = 0, [];
}
function rt(e) {
  return fe = "", e;
}
function je(e) {
  return Xr(we(z - 1, ir(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function rn(e) {
  for (; (j = H()) && j < 33; )
    U();
  return xe(e) > 2 || xe(j) > 3 ? "" : " ";
}
function tn(e, r) {
  for (; --r && U() && !(j < 48 || j > 102 || j > 57 && j < 65 || j > 70 && j < 97); )
    ;
  return we(e, Me() + (r < 6 && H() == 32 && U() == 32));
}
function ir(e) {
  for (; U(); )
    switch (j) {
      case e:
        return z;
      case 34:
      case 39:
        e !== 34 && e !== 39 && ir(j);
        break;
      case 40:
        e === 41 && ir(e);
        break;
      case 92:
        U();
        break;
    }
  return z;
}
function nn(e, r) {
  for (; U() && e + j !== 47 + 10; )
    if (e + j === 42 + 42 && H() === 47)
      break;
  return "/*" + we(r, z - 1) + "*" + We(e === 47 ? e : U());
}
function an(e) {
  for (; !xe(H()); )
    U();
  return we(e, z);
}
function on(e) {
  return rt(Ve("", null, null, null, [""], e = et(e), 0, [0], e));
}
function Ve(e, r, n, a, o, i, l, f, p) {
  for (var m = 0, d = 0, y = l, k = 0, $ = 0, A = 0, b = 1, F = 1, S = 1, E = 0, P = "", I = o, c = i, V = a, O = P; F; )
    switch (A = E, E = U()) {
      case 40:
        if (A != 108 && L(O, y - 1) == 58) {
          or(O += w(je(E), "&", "&\f"), "&\f") != -1 && (S = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        O += je(E);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        O += rn(A);
        break;
      case 92:
        O += tn(Me() - 1, 7);
        continue;
      case 47:
        switch (H()) {
          case 42:
          case 47:
            Fe(sn(nn(U(), Me()), r, n), p);
            break;
          default:
            O += "/";
        }
        break;
      case 123 * b:
        f[m++] = K(O) * S;
      case 125 * b:
      case 59:
      case 0:
        switch (E) {
          case 0:
          case 125:
            F = 0;
          case 59 + d:
            S == -1 && (O = w(O, /\f/g, "")), $ > 0 && K(O) - y && Fe($ > 32 ? Fr(O + ";", a, n, y - 1) : Fr(w(O, " ", "") + ";", a, n, y - 2), p);
            break;
          case 59:
            O += ";";
          default:
            if (Fe(V = Dr(O, r, n, m, d, o, f, P, I = [], c = [], y), i), E === 123)
              if (d === 0)
                Ve(O, r, V, V, I, i, y, f, c);
              else
                switch (k === 99 && L(O, 3) === 110 ? 100 : k) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    Ve(e, V, V, a && Fe(Dr(e, V, V, 0, 0, o, f, P, o, I = [], y), c), o, c, y, f, a ? I : c);
                    break;
                  default:
                    Ve(O, V, V, V, [""], c, 0, f, c);
                }
        }
        m = d = $ = 0, b = S = 1, P = O = "", y = l;
        break;
      case 58:
        y = 1 + K(O), $ = A;
      default:
        if (b < 1) {
          if (E == 123)
            --b;
          else if (E == 125 && b++ == 0 && en() == 125)
            continue;
        }
        switch (O += We(E), E * b) {
          case 38:
            S = d > 0 ? 1 : (O += "\f", -1);
            break;
          case 44:
            f[m++] = (K(O) - 1) * S, S = 1;
            break;
          case 64:
            H() === 45 && (O += je(U())), k = H(), d = y = K(P = O += an(Me())), E++;
            break;
          case 45:
            A === 45 && K(O) == 2 && (b = 0);
        }
    }
  return i;
}
function Dr(e, r, n, a, o, i, l, f, p, m, d) {
  for (var y = o - 1, k = o === 0 ? i : [""], $ = mr(k), A = 0, b = 0, F = 0; A < a; ++A)
    for (var S = 0, E = Se(e, y + 1, y = Jt(b = l[A])), P = e; S < $; ++S)
      (P = Xr(b > 0 ? k[S] + " " + E : w(E, /&\f/g, k[S]))) && (p[F++] = P);
  return Ue(e, r, n, o === 0 ? pr : f, p, m, d);
}
function sn(e, r, n) {
  return Ue(e, r, n, dr, We(Qt()), Se(e, 2, -2), 0);
}
function Fr(e, r, n, a) {
  return Ue(e, r, n, vr, Se(e, 0, a), Se(e, a + 1, -1), a);
}
function ce(e, r) {
  for (var n = "", a = mr(e), o = 0; o < a; o++)
    n += r(e[o], o, e, r) || "";
  return n;
}
function cn(e, r, n, a) {
  switch (e.type) {
    case Gt:
      if (e.children.length)
        break;
    case Bt:
    case vr:
      return e.return = e.return || e.value;
    case dr:
      return "";
    case Zr:
      return e.return = e.value + "{" + ce(e.children, a) + "}";
    case pr:
      e.value = e.props.join(",");
  }
  return K(n = ce(e.children, a)) ? e.return = e.value + "{" + n + "}" : "";
}
function un(e) {
  var r = mr(e);
  return function(n, a, o, i) {
    for (var l = "", f = 0; f < r; f++)
      l += e[f](n, a, o, i) || "";
    return l;
  };
}
function fn(e) {
  return function(r) {
    r.root || (r = r.return) && e(r);
  };
}
function ln(e) {
  var r = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return r[n] === void 0 && (r[n] = e(n)), r[n];
  };
}
var dn = function(r, n, a) {
  for (var o = 0, i = 0; o = i, i = H(), o === 38 && i === 12 && (n[a] = 1), !xe(i); )
    U();
  return we(r, z);
}, pn = function(r, n) {
  var a = -1, o = 44;
  do
    switch (xe(o)) {
      case 0:
        o === 38 && H() === 12 && (n[a] = 1), r[a] += dn(z - 1, n, a);
        break;
      case 2:
        r[a] += je(o);
        break;
      case 4:
        if (o === 44) {
          r[++a] = H() === 58 ? "&\f" : "", n[a] = r[a].length;
          break;
        }
      default:
        r[a] += We(o);
    }
  while (o = U());
  return r;
}, vn = function(r, n) {
  return rt(pn(et(r), n));
}, Mr = /* @__PURE__ */ new WeakMap(), mn = function(r) {
  if (!(r.type !== "rule" || !r.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  r.length < 1)) {
    for (var n = r.value, a = r.parent, o = r.column === a.column && r.line === a.line; a.type !== "rule"; )
      if (a = a.parent, !a)
        return;
    if (!(r.props.length === 1 && n.charCodeAt(0) !== 58 && !Mr.get(a)) && !o) {
      Mr.set(r, !0);
      for (var i = [], l = vn(n, i), f = a.props, p = 0, m = 0; p < l.length; p++)
        for (var d = 0; d < f.length; d++, m++)
          r.props[m] = i[p] ? l[p].replace(/&\f/g, f[d]) : f[d] + " " + l[p];
    }
  }
}, hn = function(r) {
  if (r.type === "decl") {
    var n = r.value;
    // charcode for l
    n.charCodeAt(0) === 108 && // charcode for b
    n.charCodeAt(2) === 98 && (r.return = "", r.value = "");
  }
}, yn = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason", En = function(r) {
  return r.type === "comm" && r.children.indexOf(yn) > -1;
}, gn = function(r) {
  return function(n, a, o) {
    if (!(n.type !== "rule" || r.compat)) {
      var i = n.value.match(/(:first|:nth|:nth-last)-child/g);
      if (i) {
        for (var l = !!n.parent, f = l ? n.parent.children : (
          // global rule at the root level
          o
        ), p = f.length - 1; p >= 0; p--) {
          var m = f[p];
          if (m.line < n.line)
            break;
          if (m.column < n.column) {
            if (En(m))
              return;
            break;
          }
        }
        i.forEach(function(d) {
          console.error('The pseudo class "' + d + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + d.split("-child")[0] + '-of-type".');
        });
      }
    }
  };
}, tt = function(r) {
  return r.type.charCodeAt(1) === 105 && r.type.charCodeAt(0) === 64;
}, bn = function(r, n) {
  for (var a = r - 1; a >= 0; a--)
    if (!tt(n[a]))
      return !0;
  return !1;
}, jr = function(r) {
  r.type = "", r.value = "", r.return = "", r.children = "", r.props = "";
}, _n = function(r, n, a) {
  tt(r) && (r.parent ? (console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles."), jr(r)) : bn(n, a) && (console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules."), jr(r)));
};
function nt(e, r) {
  switch (Ht(e, r)) {
    case 5103:
      return R + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return R + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return R + e + Le + e + Y + e + e;
    case 6828:
    case 4268:
      return R + e + Y + e + e;
    case 6165:
      return R + e + Y + "flex-" + e + e;
    case 5187:
      return R + e + w(e, /(\w+).+(:[^]+)/, R + "box-$1$2" + Y + "flex-$1$2") + e;
    case 5443:
      return R + e + Y + "flex-item-" + w(e, /flex-|-self/, "") + e;
    case 4675:
      return R + e + Y + "flex-line-pack" + w(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return R + e + Y + w(e, "shrink", "negative") + e;
    case 5292:
      return R + e + Y + w(e, "basis", "preferred-size") + e;
    case 6060:
      return R + "box-" + w(e, "-grow", "") + R + e + Y + w(e, "grow", "positive") + e;
    case 4554:
      return R + w(e, /([^-])(transform)/g, "$1" + R + "$2") + e;
    case 6187:
      return w(w(w(e, /(zoom-|grab)/, R + "$1"), /(image-set)/, R + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return w(e, /(image-set\([^]*)/, R + "$1$`$1");
    case 4968:
      return w(w(e, /(.+:)(flex-)?(.*)/, R + "box-pack:$3" + Y + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + R + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return w(e, /(.+)-inline(.+)/, R + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (K(e) - 1 - r > 6)
        switch (L(e, r + 1)) {
          case 109:
            if (L(e, r + 4) !== 45)
              break;
          case 102:
            return w(e, /(.+:)(.+)-([^]+)/, "$1" + R + "$2-$3$1" + Le + (L(e, r + 3) == 108 ? "$3" : "$2-$3")) + e;
          case 115:
            return ~or(e, "stretch") ? nt(w(e, "stretch", "fill-available"), r) + e : e;
        }
      break;
    case 4949:
      if (L(e, r + 1) !== 115)
        break;
    case 6444:
      switch (L(e, K(e) - 3 - (~or(e, "!important") && 10))) {
        case 107:
          return w(e, ":", ":" + R) + e;
        case 101:
          return w(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + R + (L(e, 14) === 45 ? "inline-" : "") + "box$3$1" + R + "$2$3$1" + Y + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (L(e, r + 11)) {
        case 114:
          return R + e + Y + w(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return R + e + Y + w(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return R + e + Y + w(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return R + e + Y + e + e;
  }
  return e;
}
var Sn = function(r, n, a, o) {
  if (r.length > -1 && !r.return)
    switch (r.type) {
      case vr:
        r.return = nt(r.value, r.length);
        break;
      case Zr:
        return ce([be(r, {
          value: w(r.value, "@", "@" + R)
        })], o);
      case pr:
        if (r.length)
          return Xt(r.props, function(i) {
            switch (Zt(i, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return ce([be(r, {
                  props: [w(i, /:(read-\w+)/, ":" + Le + "$1")]
                })], o);
              case "::placeholder":
                return ce([be(r, {
                  props: [w(i, /:(plac\w+)/, ":" + R + "input-$1")]
                }), be(r, {
                  props: [w(i, /:(plac\w+)/, ":" + Le + "$1")]
                }), be(r, {
                  props: [w(i, /:(plac\w+)/, Y + "input-$1")]
                })], o);
            }
            return "";
          });
    }
}, xn = [Sn], Rn = function(r) {
  var n = r.key;
  if (process.env.NODE_ENV !== "production" && !n)
    throw new Error(`You have to configure \`key\` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.
If multiple caches share the same key they might "fight" for each other's style elements.`);
  if (n === "css") {
    var a = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(a, function(b) {
      var F = b.getAttribute("data-emotion");
      F.indexOf(" ") !== -1 && (document.head.appendChild(b), b.setAttribute("data-s", ""));
    });
  }
  var o = r.stylisPlugins || xn;
  if (process.env.NODE_ENV !== "production" && /[^a-z-]/.test(n))
    throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + n + '" was passed');
  var i = {}, l, f = [];
  l = r.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + n + ' "]'),
    function(b) {
      for (var F = b.getAttribute("data-emotion").split(" "), S = 1; S < F.length; S++)
        i[F[S]] = !0;
      f.push(b);
    }
  );
  var p, m = [mn, hn];
  process.env.NODE_ENV !== "production" && m.push(gn({
    get compat() {
      return A.compat;
    }
  }), _n);
  {
    var d, y = [cn, process.env.NODE_ENV !== "production" ? function(b) {
      b.root || (b.return ? d.insert(b.return) : b.value && b.type !== dr && d.insert(b.value + "{}"));
    } : fn(function(b) {
      d.insert(b);
    })], k = un(m.concat(o, y)), $ = function(F) {
      return ce(on(F), k);
    };
    p = function(F, S, E, P) {
      d = E, process.env.NODE_ENV !== "production" && S.map !== void 0 && (d = {
        insert: function(c) {
          E.insert(c + S.map);
        }
      }), $(F ? F + "{" + S.styles + "}" : S.styles), P && (A.inserted[S.name] = !0);
    };
  }
  var A = {
    key: n,
    sheet: new qt({
      key: n,
      container: l,
      nonce: r.nonce,
      speedy: r.speedy,
      prepend: r.prepend,
      insertionPoint: r.insertionPoint
    }),
    nonce: r.nonce,
    inserted: i,
    registered: {},
    insert: p
  };
  return A.sheet.hydrate(f), A;
}, sr = { exports: {} }, C = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Vr;
function wn() {
  if (Vr)
    return C;
  Vr = 1;
  var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, a = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, l = e ? Symbol.for("react.provider") : 60109, f = e ? Symbol.for("react.context") : 60110, p = e ? Symbol.for("react.async_mode") : 60111, m = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, y = e ? Symbol.for("react.suspense") : 60113, k = e ? Symbol.for("react.suspense_list") : 60120, $ = e ? Symbol.for("react.memo") : 60115, A = e ? Symbol.for("react.lazy") : 60116, b = e ? Symbol.for("react.block") : 60121, F = e ? Symbol.for("react.fundamental") : 60117, S = e ? Symbol.for("react.responder") : 60118, E = e ? Symbol.for("react.scope") : 60119;
  function P(c) {
    if (typeof c == "object" && c !== null) {
      var V = c.$$typeof;
      switch (V) {
        case r:
          switch (c = c.type, c) {
            case p:
            case m:
            case a:
            case i:
            case o:
            case y:
              return c;
            default:
              switch (c = c && c.$$typeof, c) {
                case f:
                case d:
                case A:
                case $:
                case l:
                  return c;
                default:
                  return V;
              }
          }
        case n:
          return V;
      }
    }
  }
  function I(c) {
    return P(c) === m;
  }
  return C.AsyncMode = p, C.ConcurrentMode = m, C.ContextConsumer = f, C.ContextProvider = l, C.Element = r, C.ForwardRef = d, C.Fragment = a, C.Lazy = A, C.Memo = $, C.Portal = n, C.Profiler = i, C.StrictMode = o, C.Suspense = y, C.isAsyncMode = function(c) {
    return I(c) || P(c) === p;
  }, C.isConcurrentMode = I, C.isContextConsumer = function(c) {
    return P(c) === f;
  }, C.isContextProvider = function(c) {
    return P(c) === l;
  }, C.isElement = function(c) {
    return typeof c == "object" && c !== null && c.$$typeof === r;
  }, C.isForwardRef = function(c) {
    return P(c) === d;
  }, C.isFragment = function(c) {
    return P(c) === a;
  }, C.isLazy = function(c) {
    return P(c) === A;
  }, C.isMemo = function(c) {
    return P(c) === $;
  }, C.isPortal = function(c) {
    return P(c) === n;
  }, C.isProfiler = function(c) {
    return P(c) === i;
  }, C.isStrictMode = function(c) {
    return P(c) === o;
  }, C.isSuspense = function(c) {
    return P(c) === y;
  }, C.isValidElementType = function(c) {
    return typeof c == "string" || typeof c == "function" || c === a || c === m || c === i || c === o || c === y || c === k || typeof c == "object" && c !== null && (c.$$typeof === A || c.$$typeof === $ || c.$$typeof === l || c.$$typeof === f || c.$$typeof === d || c.$$typeof === F || c.$$typeof === S || c.$$typeof === E || c.$$typeof === b);
  }, C.typeOf = P, C;
}
var T = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Lr;
function Cn() {
  return Lr || (Lr = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, a = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, l = e ? Symbol.for("react.provider") : 60109, f = e ? Symbol.for("react.context") : 60110, p = e ? Symbol.for("react.async_mode") : 60111, m = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, y = e ? Symbol.for("react.suspense") : 60113, k = e ? Symbol.for("react.suspense_list") : 60120, $ = e ? Symbol.for("react.memo") : 60115, A = e ? Symbol.for("react.lazy") : 60116, b = e ? Symbol.for("react.block") : 60121, F = e ? Symbol.for("react.fundamental") : 60117, S = e ? Symbol.for("react.responder") : 60118, E = e ? Symbol.for("react.scope") : 60119;
    function P(v) {
      return typeof v == "string" || typeof v == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      v === a || v === m || v === i || v === o || v === y || v === k || typeof v == "object" && v !== null && (v.$$typeof === A || v.$$typeof === $ || v.$$typeof === l || v.$$typeof === f || v.$$typeof === d || v.$$typeof === F || v.$$typeof === S || v.$$typeof === E || v.$$typeof === b);
    }
    function I(v) {
      if (typeof v == "object" && v !== null) {
        var he = v.$$typeof;
        switch (he) {
          case r:
            var oe = v.type;
            switch (oe) {
              case p:
              case m:
              case a:
              case i:
              case o:
              case y:
                return oe;
              default:
                var re = oe && oe.$$typeof;
                switch (re) {
                  case f:
                  case d:
                  case A:
                  case $:
                  case l:
                    return re;
                  default:
                    return he;
                }
            }
          case n:
            return he;
        }
      }
    }
    var c = p, V = m, O = f, Be = l, Ce = r, Ge = d, Je = a, Te = A, G = $, Z = n, ee = i, Oe = o, Pe = y, le = !1;
    function Ae(v) {
      return le || (le = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), de(v) || I(v) === p;
    }
    function de(v) {
      return I(v) === m;
    }
    function Ne(v) {
      return I(v) === f;
    }
    function ke(v) {
      return I(v) === l;
    }
    function $e(v) {
      return typeof v == "object" && v !== null && v.$$typeof === r;
    }
    function Ke(v) {
      return I(v) === d;
    }
    function He(v) {
      return I(v) === a;
    }
    function pe(v) {
      return I(v) === A;
    }
    function ve(v) {
      return I(v) === $;
    }
    function ne(v) {
      return I(v) === n;
    }
    function me(v) {
      return I(v) === i;
    }
    function ae(v) {
      return I(v) === o;
    }
    function Ze(v) {
      return I(v) === y;
    }
    T.AsyncMode = c, T.ConcurrentMode = V, T.ContextConsumer = O, T.ContextProvider = Be, T.Element = Ce, T.ForwardRef = Ge, T.Fragment = Je, T.Lazy = Te, T.Memo = G, T.Portal = Z, T.Profiler = ee, T.StrictMode = Oe, T.Suspense = Pe, T.isAsyncMode = Ae, T.isConcurrentMode = de, T.isContextConsumer = Ne, T.isContextProvider = ke, T.isElement = $e, T.isForwardRef = Ke, T.isFragment = He, T.isLazy = pe, T.isMemo = ve, T.isPortal = ne, T.isProfiler = me, T.isStrictMode = ae, T.isSuspense = Ze, T.isValidElementType = P, T.typeOf = I;
  }()), T;
}
process.env.NODE_ENV === "production" ? sr.exports = wn() : sr.exports = Cn();
var Tn = sr.exports, at = Tn, On = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, Pn = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, ot = {};
ot[at.ForwardRef] = On;
ot[at.Memo] = Pn;
var An = !0;
function Nn(e, r, n) {
  var a = "";
  return n.split(" ").forEach(function(o) {
    e[o] !== void 0 ? r.push(e[o] + ";") : a += o + " ";
  }), a;
}
var it = function(r, n, a) {
  var o = r.key + "-" + n.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (a === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  An === !1) && r.registered[o] === void 0 && (r.registered[o] = n.styles);
}, kn = function(r, n, a) {
  it(r, n, a);
  var o = r.key + "-" + n.name;
  if (r.inserted[n.name] === void 0) {
    var i = n;
    do
      r.insert(n === i ? "." + o : "", i, r.sheet, !0), i = i.next;
    while (i !== void 0);
  }
};
function $n(e) {
  for (var r = 0, n, a = 0, o = e.length; o >= 4; ++a, o -= 4)
    n = e.charCodeAt(a) & 255 | (e.charCodeAt(++a) & 255) << 8 | (e.charCodeAt(++a) & 255) << 16 | (e.charCodeAt(++a) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, r = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  switch (o) {
    case 3:
      r ^= (e.charCodeAt(a + 2) & 255) << 16;
    case 2:
      r ^= (e.charCodeAt(a + 1) & 255) << 8;
    case 1:
      r ^= e.charCodeAt(a) & 255, r = /* Math.imul(h, m): */
      (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  }
  return r ^= r >>> 13, r = /* Math.imul(h, m): */
  (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16), ((r ^ r >>> 15) >>> 0).toString(36);
}
var In = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, Yr = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, Dn = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).", Fn = /[A-Z]|^ms/g, st = /_EMO_([^_]+?)_([^]*?)_EMO_/g, hr = function(r) {
  return r.charCodeAt(1) === 45;
}, Wr = function(r) {
  return r != null && typeof r != "boolean";
}, nr = /* @__PURE__ */ ln(function(e) {
  return hr(e) ? e : e.replace(Fn, "-$&").toLowerCase();
}), Ye = function(r, n) {
  switch (r) {
    case "animation":
    case "animationName":
      if (typeof n == "string")
        return n.replace(st, function(a, o, i) {
          return J = {
            name: o,
            styles: i,
            next: J
          }, o;
        });
  }
  return In[r] !== 1 && !hr(r) && typeof n == "number" && n !== 0 ? n + "px" : n;
};
if (process.env.NODE_ENV !== "production") {
  var Mn = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, jn = ["normal", "none", "initial", "inherit", "unset"], Vn = Ye, Ln = /^-ms-/, Yn = /-(.)/g, zr = {};
  Ye = function(r, n) {
    if (r === "content" && (typeof n != "string" || jn.indexOf(n) === -1 && !Mn.test(n) && (n.charAt(0) !== n.charAt(n.length - 1) || n.charAt(0) !== '"' && n.charAt(0) !== "'")))
      throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + n + "\"'`");
    var a = Vn(r, n);
    return a !== "" && !hr(r) && r.indexOf("-") !== -1 && zr[r] === void 0 && (zr[r] = !0, console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + r.replace(Ln, "ms-").replace(Yn, function(o, i) {
      return i.toUpperCase();
    }) + "?")), a;
  };
}
var ct = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function Re(e, r, n) {
  if (n == null)
    return "";
  if (n.__emotion_styles !== void 0) {
    if (process.env.NODE_ENV !== "production" && n.toString() === "NO_COMPONENT_SELECTOR")
      throw new Error(ct);
    return n;
  }
  switch (typeof n) {
    case "boolean":
      return "";
    case "object": {
      if (n.anim === 1)
        return J = {
          name: n.name,
          styles: n.styles,
          next: J
        }, n.name;
      if (n.styles !== void 0) {
        var a = n.next;
        if (a !== void 0)
          for (; a !== void 0; )
            J = {
              name: a.name,
              styles: a.styles,
              next: J
            }, a = a.next;
        var o = n.styles + ";";
        return process.env.NODE_ENV !== "production" && n.map !== void 0 && (o += n.map), o;
      }
      return Wn(e, r, n);
    }
    case "function": {
      if (e !== void 0) {
        var i = J, l = n(e);
        return J = i, Re(e, r, l);
      } else
        process.env.NODE_ENV !== "production" && console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      break;
    }
    case "string":
      if (process.env.NODE_ENV !== "production") {
        var f = [], p = n.replace(st, function(d, y, k) {
          var $ = "animation" + f.length;
          return f.push("const " + $ + " = keyframes`" + k.replace(/^@keyframes animation-\w+/, "") + "`"), "${" + $ + "}";
        });
        f.length && console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(f, ["`" + p + "`"]).join(`
`) + `

You should wrap it with \`css\` like this:

` + ("css`" + p + "`"));
      }
      break;
  }
  if (r == null)
    return n;
  var m = r[n];
  return m !== void 0 ? m : n;
}
function Wn(e, r, n) {
  var a = "";
  if (Array.isArray(n))
    for (var o = 0; o < n.length; o++)
      a += Re(e, r, n[o]) + ";";
  else
    for (var i in n) {
      var l = n[i];
      if (typeof l != "object")
        r != null && r[l] !== void 0 ? a += i + "{" + r[l] + "}" : Wr(l) && (a += nr(i) + ":" + Ye(i, l) + ";");
      else {
        if (i === "NO_COMPONENT_SELECTOR" && process.env.NODE_ENV !== "production")
          throw new Error(ct);
        if (Array.isArray(l) && typeof l[0] == "string" && (r == null || r[l[0]] === void 0))
          for (var f = 0; f < l.length; f++)
            Wr(l[f]) && (a += nr(i) + ":" + Ye(i, l[f]) + ";");
        else {
          var p = Re(e, r, l);
          switch (i) {
            case "animation":
            case "animationName": {
              a += nr(i) + ":" + p + ";";
              break;
            }
            default:
              process.env.NODE_ENV !== "production" && i === "undefined" && console.error(Dn), a += i + "{" + p + "}";
          }
        }
      }
    }
  return a;
}
var Ur = /label:\s*([^\s;\n{]+)\s*(;|$)/g, ut;
process.env.NODE_ENV !== "production" && (ut = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g);
var J, qr = function(r, n, a) {
  if (r.length === 1 && typeof r[0] == "object" && r[0] !== null && r[0].styles !== void 0)
    return r[0];
  var o = !0, i = "";
  J = void 0;
  var l = r[0];
  l == null || l.raw === void 0 ? (o = !1, i += Re(a, n, l)) : (process.env.NODE_ENV !== "production" && l[0] === void 0 && console.error(Yr), i += l[0]);
  for (var f = 1; f < r.length; f++)
    i += Re(a, n, r[f]), o && (process.env.NODE_ENV !== "production" && l[f] === void 0 && console.error(Yr), i += l[f]);
  var p;
  process.env.NODE_ENV !== "production" && (i = i.replace(ut, function(k) {
    return p = k, "";
  })), Ur.lastIndex = 0;
  for (var m = "", d; (d = Ur.exec(i)) !== null; )
    m += "-" + // $FlowFixMe we know it's not null
    d[1];
  var y = $n(i) + m;
  return process.env.NODE_ENV !== "production" ? {
    name: y,
    styles: i,
    map: p,
    next: J,
    toString: function() {
      return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
  } : {
    name: y,
    styles: i,
    next: J
  };
}, zn = function(r) {
  return r();
}, Un = Q["useInsertionEffect"] ? Q["useInsertionEffect"] : !1, qn = Un || zn, qe = {}.hasOwnProperty, yr = /* @__PURE__ */ Q.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ Rn({
    key: "css"
  }) : null
);
process.env.NODE_ENV !== "production" && (yr.displayName = "EmotionCacheContext");
yr.Provider;
var Bn = function(r) {
  return /* @__PURE__ */ Hr(function(n, a) {
    var o = Mt(yr);
    return r(n, o, a);
  });
}, ft = /* @__PURE__ */ Q.createContext({});
process.env.NODE_ENV !== "production" && (ft.displayName = "EmotionThemeContext");
var Br = function(r) {
  var n = r.split(".");
  return n[n.length - 1];
}, Gn = function(r) {
  var n = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(r);
  if (n || (n = /^([A-Za-z0-9$.]+)@/.exec(r), n))
    return Br(n[1]);
}, Jn = /* @__PURE__ */ new Set(["renderWithHooks", "processChild", "finishClassComponent", "renderToString"]), Kn = function(r) {
  return r.replace(/\$/g, "-");
}, Hn = function(r) {
  if (r)
    for (var n = r.split(`
`), a = 0; a < n.length; a++) {
      var o = Gn(n[a]);
      if (o) {
        if (Jn.has(o))
          break;
        if (/^[A-Z]/.test(o))
          return Kn(o);
      }
    }
}, cr = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", ur = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__", lt = function(r, n) {
  if (process.env.NODE_ENV !== "production" && typeof n.css == "string" && // check if there is a css declaration
  n.css.indexOf(":") !== -1)
    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/react' like this: css`" + n.css + "`");
  var a = {};
  for (var o in n)
    qe.call(n, o) && (a[o] = n[o]);
  if (a[cr] = r, process.env.NODE_ENV !== "production" && n.css && (typeof n.css != "object" || typeof n.css.name != "string" || n.css.name.indexOf("-") === -1)) {
    var i = Hn(new Error().stack);
    i && (a[ur] = i);
  }
  return a;
}, Zn = function(r) {
  var n = r.cache, a = r.serialized, o = r.isStringTag;
  return it(n, a, o), qn(function() {
    return kn(n, a, o);
  }), null;
}, dt = /* @__PURE__ */ Bn(function(e, r, n) {
  var a = e.css;
  typeof a == "string" && r.registered[a] !== void 0 && (a = r.registered[a]);
  var o = e[cr], i = [a], l = "";
  typeof e.className == "string" ? l = Nn(r.registered, i, e.className) : e.className != null && (l = e.className + " ");
  var f = qr(i, void 0, Q.useContext(ft));
  if (process.env.NODE_ENV !== "production" && f.name.indexOf("-") === -1) {
    var p = e[ur];
    p && (f = qr([f, "label:" + p + ";"]));
  }
  l += r.key + "-" + f.name;
  var m = {};
  for (var d in e)
    qe.call(e, d) && d !== "css" && d !== cr && (process.env.NODE_ENV === "production" || d !== ur) && (m[d] = e[d]);
  return m.ref = n, m.className = l, /* @__PURE__ */ Q.createElement(Q.Fragment, null, /* @__PURE__ */ Q.createElement(Zn, {
    cache: r,
    serialized: f,
    isStringTag: typeof o == "string"
  }), /* @__PURE__ */ Q.createElement(o, m));
});
process.env.NODE_ENV !== "production" && (dt.displayName = "EmotionCssPropInternal");
var pt = dt, Gr = _e.Fragment;
function te(e, r, n) {
  return qe.call(r, "css") ? _e.jsx(pt, lt(e, r), n) : _e.jsx(e, r, n);
}
function Xn(e, r, n) {
  return qe.call(r, "css") ? _e.jsxs(pt, lt(e, r), n) : _e.jsxs(e, r, n);
}
const Er = "#F9FAFC", Qn = "#F2F3F5", ea = B`
  display: flex;
`, ra = B`
  flex-grow: 1;
  overflow: hidden;
`, ta = B`
  margin-right: 16px;
`;
function vt(e) {
  if (!e)
    return B``;
  const r = Lt`
  0% {
    background-position: 100% 50%
  }

  100% {
    background-position: 0 50%
  }
  `, n = Er;
  return B({
    background: `linear-gradient(90deg, ${n} 20%, ${Qn} 35%, ${n} 65%)`,
    backgroundSize: "400% 100%",
    animation: `${r} 1.5s linear infinite`
  });
}
function na(e) {
  return B`
    &:not(:last-child) {
      margin-bottom: 16px;
    }
    width: ${e}px;
    height: 16px;
    background-color: ${Er}px;
  `;
}
const aa = B({
  listStyle: "none",
  padding: 0,
  margin: 0
});
function oa({ shape: e = "circle", size: r = "medium" }) {
  return B([
    B`
      background-color: ${Er};
    `,
    ia(r),
    sa(e)
  ]);
}
function ia(e) {
  let r;
  return typeof e == "number" ? r = e : r = {
    small: 36,
    medium: 48,
    large: 60
  }[e], B`
    width: ${r}px;
    height: ${r}px;
  `;
}
function sa(e) {
  return e === "circle" ? B`
        border-radius: 50%;
      ` : B``;
}
function mt(e) {
  const { rows: r = 3, width: n = "80%", animation: a, ...o } = e, i = Array.from({ length: r }, (l, f) => {
    let p;
    return jt(n) ? p = n[f] : f === r - 1 && (p = n), te("li", { css: [na(p), vt(a)] }, f);
  });
  return te("ul", { css: [aa, fr(e)], ...lr(o), children: i });
}
mt.displayName = "SkeletonText";
function ht(e) {
  const { shape: r = "circle", size: n = "medium", animation: a, ...o } = e;
  return te("div", { css: [
    oa({ shape: r, size: n }),
    vt(a),
    fr(e)
  ], ...lr(o) });
}
ht.displayName = "SkeletonImage";
function Jr(e) {
  return Vt(e) ? e : {};
}
const ca = Hr((e, r) => {
  const { animation: n, visible: a = !0, image: o, text: i = !0, children: l, ...f } = e, p = kr(() => {
    if (!i)
      return te(Gr, {});
    const d = Jr(i);
    return te(mt, { css: [ra], animation: n, ...d });
  }, [n, i]), m = kr(() => {
    if (!o)
      return null;
    const d = Jr(o);
    return te(ht, { css: [ta], animation: n, ...d });
  }, [n, o]);
  return a ? Xn("div", { ref: r, css: [ea, fr(e)], ...lr(f), children: [m, p] }) : te(Gr, { children: l });
});
ca.displayName = "Skeleton";
export {
  ca as Skeleton
};
//# sourceMappingURL=index.js.map
